import { MdOutlineCheck } from "react-icons/md";

import { formatToPersianClock, formatToPersianDate } from "../../../../utils";
import PersianNumber from "../../../../utils/PersianNumber/PersianNumber";

const CustomerLastMobileView = ({ _item }) => {
  return (
    <>
      {_item?.transactions?.map((_item) => (
        <>
          <div
            key={_item?.id}
            className="w-full h-full rounded-xl bg-boxColor relative
            my-4 py-4 animate__animated animate__fadeIn animate__slow"
          >
            {/* Information */}
            <span
              className="flex flex-col justify-center items-center space-y-5
           w-full animate__animated animate__flipInX animate__fast"
            >
              {/* Items */}
              <div className="space-y-3 font-medium text-base w-full">
                {/* Title */}
                <span
                  className={`${
                    _item?.bos === "B" ? "text-[#00FF00]" : "text-[#FF073A]"
                  } font-medium text-lg w-full flex justify-center`}
                >
                  <span>معامله</span>
                  <span className="px-1">
                    {_item?.bos === "B" ? "خرید" : "فروش"}{" "}
                  </span>
                  <span className="text-gray-100">{_item?.product_name}</span>
                </span>
                {/* Items */}
                <span className="grid grid-cols-2 w-full px-3 tracking-wide">
                  {/* Right Column */}
                  <ul className="flex flex-col text-right w-full text-gray-200 space-y-5">
                    {/* Transaction ID */}
                    <li>
                      <span>شماره سفارش</span>
                    </li>
                    {/* Order Status */}
                    <li>
                      <span>وضعیت</span>
                    </li>
                    {/* Volume */}
                    <li>
                      <span className="flex">
                        حجم
                        <p className="text-xs px-1 flex items-center text-[#00BFFF]">
                          ( {_item.tag === "S" ? "تعداد" : "مقدار (گرم)"} )
                        </p>
                      </span>
                    </li>
                    {/* Price */}
                    <li>
                      <span className="flex">
                        قیمت
                        <p className="text-xs px-1 flex items-center text-[#00BFFF]">
                          ( تومان )
                        </p>
                      </span>
                    </li>
                    {/* Total */}
                    <li>
                      <span className="flex">
                        مبلغ
                        <p className="text-xs px-1 flex items-center text-[#00BFFF]">
                          ( تومان )
                        </p>
                      </span>
                    </li>
                    {/* Ordery Status */}
                    <li>
                      <span>اردری</span>
                    </li>
                    {/* User Name */}
                    <li>
                      <span>توضیحات</span>
                    </li>
                    {/* Date */}
                    <li>
                      <span>تاریخ</span>
                    </li>
                  </ul>
                  {/* Left Column */}
                  <ul className="flex flex-col text-left w-full text-gray-50 space-y-5">
                    {/* Transaction ID */}
                    <li>
                      <span>#{_item?.transaction_id}</span>
                    </li>
                    {/* Order Status */}
                    <li>
                      <span>
                        <span className="px-1 text-xs">
                          {_item?.tType === "T" && (
                            <span className="text-[#00FF00] cursor-pointer">
                              تأیید شده
                            </span>
                          )}
                          {_item?.tType === "L" && (
                            <>
                              <span className="text-[#FF073A] cursor-pointer">
                                لغو شده
                              </span>
                            </>
                          )}
                        </span>
                      </span>
                    </li>
                    {/* Volume */}
                    <li>
                      <span>
                        <PersianNumber
                          value={_item?.volume}
                          thousandSeparator=","
                        />
                      </span>
                    </li>
                    {/* Price */}
                    <li>
                      <span className="flex justify-end">
                        <PersianNumber
                          value={_item?.price}
                          thousandSeparator=","
                        />
                      </span>
                    </li>
                    {/* Total */}
                    <li>
                      <span className="flex justify-end">
                        <PersianNumber
                          value={_item?.amount}
                          thousandSeparator=","
                        />
                      </span>
                    </li>
                    {/* Ordery Status */}
                    <li>
                      <span className="flex justify-end">
                        {_item?.is_orderi ? (
                          <MdOutlineCheck size={26} fill="#00BFFF" />
                        ) : (
                          <span className="text-slate-300">-</span>
                        )}
                      </span>
                    </li>
                    {/* Description */}
                    <li>
                      <span>
                        {_item?.description ? (
                          <>{_item?.description}</>
                        ) : (
                          <span className="text-slate-300">-</span>
                        )}
                      </span>
                    </li>
                    {/* Date */}
                    <li>
                      <span>
                        {formatToPersianClock(_item?.date_create)}
                        <span className="px-2">-</span>
                        {formatToPersianDate(_item?.date_create)}
                      </span>
                    </li>
                  </ul>
                </span>
              </div>
            </span>
          </div>
        </>
      ))}
    </>
  );
};

export default CustomerLastMobileView;
